import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from '@mui/material'
import { useState } from 'react'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

export default function CalendarListDistricts({ control, data, title, setValue, getValues }) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const handleClick = () => {
    setOpen(true)
  }
  const handleDelete = e => {
    const list = getValues()?.locationIds?.filter(item => item !== e)
    setValue('locationIds', [...list])
  }

  if (!(control && data && title)) return null

  return (
    <Grid item xs={12} md={12} sx={{ mt: 2 }}>
      <Controller
        name="locationIds"
        control={control}
        render={({ field: { value, ...field }, fieldState }) => {
          return (
            <FormControl sx={{ width: '100%' }}>
              <InputLabel id="multiple-chip-label" sx={{ width: 300, mb: 1, top: '-7px' }}>
                {t(title)}
              </InputLabel>
              <Select
                open={open}
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                size="small"
                multiple
                label={t(title)}
                error={!!fieldState.error}
                value={value || []}
                {...field}
                renderValue={selected => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected?.map(select => {
                      const found = data?.find(d => d.id === select)
                      return found ? (
                        <Chip
                          key={select}
                          variant="outlined"
                          label={`${found.name}`}
                          onClick={() => handleClick(select)}
                          onDelete={() => handleDelete(select)}
                          onMouseDown={event => {
                            event.stopPropagation()
                          }}
                        />
                      ) : null
                    })}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {data?.map(item => (
                  <MenuItem key={item?.id} value={item?.id}>
                    <Checkbox checked={value?.indexOf(item?.id) > -1} color="primary" />
                    <ListItemText primary={item?.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )
        }}
      />
    </Grid>
  )
}
